import React from "react"

const Prose = ({children}) => (
    <article className="prose prose-neutral prose-lg max-w-none prose-green dark:prose-invert dark:prose-hr:border-neutral-600 dark:prose-tr:border-neutral-600">
        {children}
    </article>
)

export default Prose